import PropTypes from 'prop-types'
import React from 'react'
import {Container} from 'semantic-ui-react'

import * as styles from './NavBarChildren.less'

const NavBarChildren = ({children}) => <Container fluid className={styles.container}>{children}</Container>;

NavBarChildren.propTypes = {
    children: PropTypes.node,
};

export default NavBarChildren



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBarChildren.js